import React, {FC} from 'react'

import {combine} from '../styles/classname-utils'
import classes from './basic-page-heading.module.scss'

const BasicPageHeading: FC = ({children}) => (
  <h1 className={combine(classes.heading, 'offset-md-1')}>{children}</h1>
)

export default BasicPageHeading
